import { Button } from "@mui/material";
import {
  Dropdown,
  InputBox,
  Icon,
  Pagination as DynamicPagination,
  DateRangePicker,
  Modal,
} from "@components";
import { formatCurrency } from "@utils";
import {
  CDBalanceAmountListRender,
  CDBalanceOTPStep,
} from "@components/CDBalanceShared";
import {
  PREMIUM_CD_BALANCE_STATUS,
  useCDBalanceData,
} from "./cdBalancePremiumData";
import "./index.scss";

const CDBalancePremium = () => {
  const {
    // State
    balanceAmount,
    error,
    loading,
    currentBalance,
    fromDate,
    toDate,
    selectedStatusFilter,
    otpDetails,

    // Data
    premiumCdBalances: paginatedCDBalances,
    allCDBalances: premiumCdBalances,
    currentPage,

    // Handlers
    handleAmountChange,
    handleClearFilters,
    handleSubmit,
    handleDownloadMIS,
    handleDateChange,
    handlePageChange,
    handleStatusFilterChange,
    handleOtpChange,
    handleCloseOtpModal,
    handleOtpSubmit,
    handleResendOTP,
  } = useCDBalanceData();

  return (
    <div className="cd-balance-premium-page">
      <div className="cd-balance-premium-page__header">
        <div className="cd-balance-premium-page__header-content">
          <h1 className="cd-balance-premium-page__title">
            C/D Balance Premium Management
          </h1>
          <p className="cd-balance-premium-page__subtitle">
            Manage ATP credit/debit balance for premium
          </p>
        </div>

        <button
          className="cd-balance-premium-page__download-btn"
          onClick={handleDownloadMIS}
          type="button"
        >
          <Icon
            iconName="downlaodIcon"
            height={16}
            width={16}
            className="download-icon"
          />
          Download Data
        </button>
      </div>

      <div className="cd-balance-premium-page__content">
        <h2 className="cd-balance-premium-page__balance-section">
          Current C/D Balance ={" "}
          <span className="cd-balance-premium-page__balance-section-data">
            {formatCurrency(currentBalance)}
          </span>
        </h2>

        <div className="cd-balance-premium-page__input-wrapper">
          <InputBox
            label="Enter Balance Amount"
            value={balanceAmount}
            onChange={handleAmountChange}
            type="text"
            placeholder="Enter amount (numbers only)"
            error={!!error}
            helperText={error}
            fullWidth={false}
            className="cd-balance-premium-page__input"
            inputMode="decimal"
          />

          <Button
            variant="contained"
            onClick={handleSubmit}
            className="cd-balance-premium-page__submit-btn"
            disabled={!balanceAmount}
          >
            Submit
          </Button>
        </div>
      </div>

      <div className="cd-balance-premium-page__amount-list-table">
        <div className="cd-balance-premium-page__table-container">
          <div className="cd-balance-premium-page__table-header">
            <h2 className="cd-balance-premium-page__table-title">
              Transaction History
            </h2>
            <div className="cd-balance-premium-page__filter-controls">
              <Dropdown
                label="Transaction Type"
                value={selectedStatusFilter}
                onChange={handleStatusFilterChange}
                options={PREMIUM_CD_BALANCE_STATUS}
                className="cd-balance-premium-page__status-dropdown"
              />
              <DateRangePicker
                fromDate={fromDate}
                toDate={toDate}
                onChange={handleDateChange}
                className="cd-balance-premium-page__date-range-picker"
              />
            </div>
          </div>
          <button
            className="cd-balance-premium-page__clear-btn"
            onClick={handleClearFilters}
            type="button"
          >
            Reset Filters
          </button>
        </div>

        <CDBalanceAmountListRender
          amounts={paginatedCDBalances}
          loading={loading}
          error={null}
          onClearFilters={handleClearFilters}
          classPrefix="cd-balance-premium"
        />

        <DynamicPagination
          data={premiumCdBalances}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          itemsPerPage={10}
          showInfo
          showFirstButton
          showLastButton
        />
      </div>

      {otpDetails.showOtpDrawer && (
        <Modal
          isOpen={otpDetails.showOtpDrawer}
          onClose={handleCloseOtpModal}
          className="cd-balance-premium-page__modal"
          closeOnOutsideClick={false}
          showCloseIcon
        >
          <CDBalanceOTPStep
            otpVal={otpDetails.otpValue}
            otpError={otpDetails.otpError}
            loading={otpDetails.otpSubmitLoading}
            handleChange={handleOtpChange}
            handleSubmit={handleOtpSubmit}
            handleResend={handleResendOTP}
            handleCloseOtpModal={handleCloseOtpModal}
            classPrefix="cd-balance-premium"
          />
        </Modal>
      )}
    </div>
  );
};

export default CDBalancePremium;
